import { TraitRegistryItem } from '../TraitRegistryItem';
import { runtime } from '../../../classes/runtime/Runtime';
export class TraitTypeSelectMultiple extends TraitRegistryItem {
    constructor(init) {
        super(init);
        Object.assign(this, init);
    }
    select;
    get selectItems() {
        return this.select || runtime.solidPackages.Edit.registryMetaInfo.traits[this.key].select || [];
    }
}
